module.exports = __webpack_public_path__ + "static/images/components/ChallengeContent/components/Label/images/label-results.064e7f86.png";


//////////////////
// WEBPACK FOOTER
// ./components/ChallengeContent/components/Label/images/label-results.png
// module id = 2588
// module chunks = 11